module.exports = __webpack_public_path__ + "h5/img/logo2.08b295a3.png";